<template>
    <div class="StaffServiceCont">
        <!-- <iframe src="https://work.weixin.qq.com/kfid/kfcf3f4f2f9449e85db" frameborder="0" style="width: 20vw;height: 50vh;"></iframe> -->
        <a href="https://work.weixin.qq.com/kfid/kfcf3f4f2f9449e85db" target="_blank"> <img
                src="@/assets/img/机器人头 1@2x.png" alt="" style="height: 50px" />
        </a>
    </div>
</template>
<script setup>
import {
    onMounted,
    onBeforeMount,
    onBeforeUnmount,
} from "vue";

// //挂载前
onBeforeMount(() => { })

// //挂载
onMounted(() => { })

// //销毁
onBeforeUnmount(() => { })
</script>
<style lang="scss" scoped>
.StaffServiceCont {
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 44;
}
</style>
